import styled from "styled-components";

export const AppWrapper = styled.div`
  width: 100%;
  overflow: hidden;
`;
export const Header = styled.header``;
